import axios from 'axios'
import Environment from '@/environments/environment.js'
import CredentialsService from '@/services/CredentialsService.js'

const baseDomain = Environment.PASSAGE_API_URL
const baseURL = `${baseDomain}`

const repository = axios.create({
  baseURL: baseURL
})

repository.interceptors.request.use(function (config) {
  // Do something before request is sent
  if (CredentialsService.isAuthenticated()) {
    const token = CredentialsService.getToken()
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

// Add a response interceptor
repository.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  console.log(error)

  return Promise.reject(error)
})

export default repository
